<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[
        { name: 'Dividend History', to: { path: '/dividend-history' } },
        {
          name: 'Edit Dividend History Page Title',
          to: {
            path: '/dividend-history/edit-dividend-history-page-title',
          },
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯Dividend History Page Title</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- block -->
    <div class="block">
      <!-- PageTitle -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>PageTitle</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="form-input-group mb-1">
            <input type="text" />
          </div>
          <div class="h5 ink-02-medium--text text-right">0/50</div>
        </div>
      </label>
      <!-- Background -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-3">Background</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸：1920px*300px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <ImgUploader></ImgUploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  components: {
    Breadscrumbs,
    ImgUploader,
  },
  methods: {
    cancelHandler() {
      this.$router.push('/dividend-history');
    },
    saveHandler() {
      this.$router.push('/dividend-history');
    },
  },
};
</script>

<style></style>
